
const tables = [
  {
    name: "Customer",
  },
  {
    name: "Contact",
  },
  {
    name: "Total Receivable",
  },
  {
    name: "0-30 Days",
  },
  {
    name: "31-60 Days",
  },
  {
    name: "61-90 Days",
  },
  {
    name: "90+ Days",
  },
  {
    name: "Terms",
  },
  {
    name: "Due Date",
  },
 /*  {
    name: "Status",
  },
  {
    name: "Action",
  }, */
];

export default tables;